export type ToolGroupId = 'docs' | 'collaboration' | 'devops' | 'environment' | 'tools';

export interface ToolDefinition {
  id: string;
  name: string;
  provider?: string;
  alwaysEnabled?: boolean;
}

export interface ToolGroupDefinition {
  id: ToolGroupId;
  name: string;
  description?: string;
  icon?: string;
  tools: ToolDefinition[];
  alwaysEnabled?: boolean;
}

export interface ToolSelectionEntry {
  enabled: boolean;
}

export type ToolSelection = Record<string, ToolSelectionEntry>;

export const TOOL_GROUPS: ToolGroupDefinition[] = [
  {
    id: 'docs',
    name: 'Docs',
    icon: 'ReadingMode',
    tools: [
      { id: 'microsoft-learn', name: 'Microsoft Learn' },
      { id: 'talxis-docs', name: 'TALXIS Docs' },
      { id: 'strategy', name: 'Strategy' },
    ],
  },
  {
    id: 'collaboration',
    name: 'Collaboration',
    icon: 'People',
    tools: [
      { id: 'chats', name: 'Chats', provider: 'Microsoft Teams' },
      { id: 'documents', name: 'Documents', provider: 'SharePoint' },
      { id: 'email', name: 'Email', provider: 'Outlook' },
      { id: 'meetings', name: 'Meetings', provider: 'Outlook' },
      { id: 'calendar', name: 'Calendar', provider: 'Outlook' },
      { id: 'notes', name: 'Notes', provider: 'Microsoft Loop' },
    ],
  },
  {
    id: 'devops',
    name: 'DevOps',
    icon: 'DeveloperTools',
    tools: [
      { id: 'code', name: 'Code', provider: 'Azure DevOps or GitHub' },
      { id: 'backlog', name: 'Backlog', provider: 'Azure DevOps or Jira' },
      { id: 'pipelines', name: 'Pipelines', provider: 'Azure DevOps' },
      { id: 'tickets', name: 'Tickets', provider: 'Jira Service Management' },
    ],
  },
  {
    id: 'environment',
    name: 'Environment Runtime',
    description: 'Power Platform / Dataverse',
    icon: 'Database',
    tools: [
      { id: 'data', name: 'Data' },
      { id: 'logs', name: 'Logs' },
      { id: 'files', name: 'Files' },
      { id: 'metadata', name: 'Metadata' },
    ],
  },
  {
    id: 'tools',
    name: 'Content',
    icon: 'Toolbox',
    alwaysEnabled: true,
    tools: [
      { id: 'excel', name: 'Excel', alwaysEnabled: true },
      { id: 'pdf', name: 'PDF', alwaysEnabled: true },
      { id: 'word', name: 'Word', alwaysEnabled: true },
    ],
  },
];

export function getDefaultToolSelection(): ToolSelection {
  const selection: ToolSelection = {};
  for (const group of TOOL_GROUPS) {
    for (const tool of group.tools) {
      selection[tool.id] = { enabled: !!tool.alwaysEnabled };
    }
  }
  return selection;
}

export function countSelectedTools(selection: ToolSelection): number {
  return Object.values(selection).filter((e) => e.enabled).length;
}

export function getSelectedToolNames(selection: ToolSelection): string[] {
  const allTools = TOOL_GROUPS.flatMap((g) => g.tools);
  return allTools
    .filter((t) => selection[t.id]?.enabled && !t.alwaysEnabled)
    .map((t) => t.name);
}
